import { Separator } from '@uturn/ui-kit';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { BlacklistedCarriersTable } from '../components/blacklisted-carriers-table';

export const BlacklistedCarriers = () => {
	const { t } = useTranslation();
	return (
		<>
			<Helmet
				title={t(
					'pages.account.organisation.blacklisted_carriers.title',
					'Organisation - Blacklisted Carriers',
				).toString()}
			/>
			<Suspense
				fallback={
					<p>
						{t(
							'pages.account.organisation.blacklisted_carriers.loading',
							'Loading carriers...',
						)}
					</p>
				}
			>
				<div className="space-y-6">
					<div>
						<h3 className="text-lg font-medium">
							{t(
								'pages.account.organisation.blacklisted_carriers.title',
								'Blacklisted Carriers',
							)}
						</h3>
						<p className="text-sm text-muted-foreground">
							{t(
								'pages.account.organisation.blacklisted_carriers.description',
								'A complete list of carriers that are currently blacklisted.',
							)}
						</p>
					</div>
					<Separator />
					<BlacklistedCarriersTable />
				</div>
			</Suspense>
		</>
	);
};
